import $ from 'jquery';

// eslint-disable-next-line no-undef
globalThis.jQuery = $;
